import { createSlice } from '@reduxjs/toolkit'
import {
  createBatch,
  createBranch,
  createBranchClassroom,
  editBranch,
  getAllCourse,
  getBatch,
  getBatchOptionList,
  getBranch,
  getBranchListData,
  getClassRoom,
  getFaculties,
  getSoloBranch,
} from '../../builders/branch/branch.builder'
const initialState = {
  loading: false,
  formEditId: null,
  branchTableData: [],
  batchData: [],
  classroomData: [],
  facultiesData: [],
  courses: [],
  branches: [],
  batches: [],
  soloBranch: [],
  batchListByBranchId: []
}

const branchSlice = createSlice({
  name: 'branch',
  initialState,
  reducers: {
    setFormEditBranchId: (state, action) => {
      state.formEditId = action.payload
    },
    updateBranchData: (state, action) => {
      state.telephonicTableData = action.payload
    },
    clearExtraReducers: (state) => {
      state.loading = false
      state.formEditId = null
      state.city = []
      state.area = []
      state.state = []
      // state.branchTableData = []
      state.batchData = []
      state.classroomData = []
      state.facultiesData = []
      state.soloBranch = []
    },
  },
  extraReducers: (builder) => {
    builder.addCase(createBranch.pending, (state) => {
      state.loading = true
      state.branchTableData = []
    })
    builder.addCase(createBranch.fulfilled, (state) => {
      state.loading = false
    })
    builder.addCase(createBranch.rejected, (state) => {
      state.loading = false
    })
    builder.addCase(editBranch.pending, (state) => {
      state.loading = true
      state.branchTableData = []
    })
    builder.addCase(editBranch.fulfilled, (state) => {
      state.loading = false
    })
    builder.addCase(editBranch.rejected, (state) => {
      state.loading = false
    })
    builder.addCase(getBranch.pending, (state) => {
      state.loading = true
      // state.branchTableData = []
    })
    builder.addCase(getBranch.fulfilled, (state, action) => {
      state.loading = false
      state.branchTableData = action.payload
    })
    builder.addCase(getBranch.rejected, (state) => {
      state.loading = false
    })
    builder.addCase(getBatch.pending, (state) => {
      state.loading = true
      // state.branchTableData = []
    })
    builder.addCase(getBatch.fulfilled, (state, action) => {
      state.loading = false
      state.batchData = action.payload
    })
    builder.addCase(getBatch.rejected, (state) => {
      state.loading = false
    })
    builder.addCase(getClassRoom.pending, (state) => {
      state.loading = true
      // state.branchTableData = []
    })
    builder.addCase(getClassRoom.fulfilled, (state, action) => {
      state.loading = false
      state.classroomData = action.payload
    })
    builder.addCase(getClassRoom.rejected, (state) => {
      state.loading = false
    })
    builder.addCase(getFaculties.pending, (state) => {
      state.loading = true
      // state.branchTableData = []
    })
    builder.addCase(getFaculties.fulfilled, (state, action) => {
      state.loading = false
      state.facultiesData = action.payload
    })
    builder.addCase(getFaculties.rejected, (state) => {
      state.loading = false
    })
    builder.addCase(createBranchClassroom.pending, (state) => {
      state.loading = true
    })
    builder.addCase(createBranchClassroom.fulfilled, (state) => {
      state.loading = false
    })
    builder.addCase(createBranchClassroom.rejected, (state) => {
      state.loading = false
    })
    
    builder.addCase(getAllCourse.pending, (state) => {
      state.loading = true
    })
    builder.addCase(getAllCourse.fulfilled, (state, action) => {
      state.loading = false
      state.courses = action.payload
    })
    builder.addCase(getAllCourse.rejected, (state) => {
      state.loading = false
    })
    builder.addCase(getBranchListData.pending, (state) => {
      state.loading = true
    })
    builder.addCase(getBranchListData.fulfilled, (state, action) => {
      state.loading = false
      state.branches = action.payload
    })
    builder.addCase(getBranchListData.rejected, (state) => {
      state.loading = false
    })
    builder.addCase(createBatch.pending, (state) => {
      state.loading = true
    })
    builder.addCase(createBatch.fulfilled, (state) => {
      state.loading = false
    })
    builder.addCase(createBatch.rejected, (state) => {
      state.loading = false
    })
    builder.addCase(getSoloBranch.pending, (state) => {
      state.loading = true
    })
    builder.addCase(getSoloBranch.fulfilled, (state, action) => {
      state.loading = false
      state.soloBranch = action.payload
    })
    builder.addCase(getSoloBranch.rejected, (state) => {
      state.loading = false
    })
    builder.addCase(getBatchOptionList.pending, (state) => {
      state.loading = true
    })
    builder.addCase(getBatchOptionList.fulfilled, (state, action) => {
      state.loading = false
      state.batchListByBranchId = action.payload
    })
    builder.addCase(getBatchOptionList.rejected, (state) => {
      state.loading = false
    })
  },
})

export const { setFormEditBranchId, updateBranchData } = branchSlice.actions

export default branchSlice.reducer
